if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
        list: this.querySelector('.disclosure__list'),
        search: this.querySelector('.locale-search'),
        listItems: this.querySelectorAll('.disclosure__list-wrapper a:not(.external-link)'),
        closeButton: this.querySelector('#close-wrapper')
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.elements.listItems.forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

      if (this.elements.search) {
        this.elements.search.addEventListener('input', this.onSearch.bind(this));
      }

      if (this.elements.closeButton) {
        this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      if (this.elements.search) this.elements.search.value = '';
      this.filterList('');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      const hidden = this.elements.panel.hasAttribute('hidden');
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', hidden.toString());

      if (!this.elements.panel.hasAttribute('calculated-width')) {
        const maxWidth = Array.from(this.elements.listItems).reduce((max, item) => {
          const width = item.offsetWidth;
          return width > max ? width : max;
        }, 0);

        this.elements.panel.style.minWidth = `${maxWidth + 26}px`;
        this.elements.panel.style.maxWidth = '100%';
        this.elements.panel.setAttribute('calculated-width', maxWidth + 26);
      }

      if (window.innerWidth < 768) {
        window.scrollTo({
          top: this.elements.panel.offsetTop - 20,
          behavior: 'smooth'
        });
      }

      if (this.elements.search) this.elements.search.focus();

      window.addEventListener('keyup', function(event) {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.hidePanel();
          this.elements.button.focus();
        }
      });
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }

    onSearch(event) {
      const term = event.target.value.trim().toLowerCase();
      this.filterList(term);
    }

    filterList(term) {
      this.elements.listItems.forEach(item => {
        const text = item.textContent.toLowerCase();
        item.parentElement.style.display = text.includes(term) ? '' : 'none';
      });
    }
  });
}
